module.exports = __webpack_public_path__ + "img/mnisw_kolor.b37078ed.webp";